import { AppData, Lightning, Utils } from '@lightningjs/sdk'
import { Helper } from '../lib/helper'
import { Badge, Base, ScrollWrapper, TextBox } from '@lightningjs/ui-components'
import { ItemNode } from '../lib/components/grid/ItemNode'
import { AppSetup } from '../lib/app-setup'
import { AppApiConfig } from '../lib/app-api-config'


export default class PlayerInfoUI extends Lightning.Component {

    isVisible = false;

    static override _template(): Lightning.Component.Template {
        return {
            Container: {
                w: (w) => w / 2 - 30,
                h: (h) => h,
                rect: true,
                color: 0xFF0D0D1D,
                alpha: 0.9,
                zIndex: 100,
                LogoContainer: {
                    BackButton: {
                        x: 60,
                        y: 178,
                        collision: true,
                        texture: {
                            src: Utils.asset('images/ico-back.png'),
                            resizeMode: {
                                h: 40,
                                w: 40,
                                type: 'contain',
                            },
                            type: Lightning.textures.ImageTexture
                        }
                    },
                    Logo: { x: 130, y: 168 },
                },
                InfoTextWrapper: {
                    x: 130,
                    y: 220,
                    zIndex: 2,
                    flex: { direction: 'column', },
                    Title: { y: 20, text: { text: '', fontFace: Helper.getFontFamily('Black'), fontSize: 42, wordWrapWidth: 700, maxLines: 2, maxLinesSuffix: '...', textOverflow: 'ellipsis' } },
                    ItemMetadataWrapper: {
                        y: 20,
                        flex: { direction: 'row', wrap: false },
                        rect: true, color: 0x00000000,
                        children: []
                    },
                    Description: { y: 30, text: { text: '', fontSize: 24, fontFace: Helper.getFontFamily('Regular'), wordWrapWidth: 700, lineHeight: 40, letterSpacing: 0.5 }},
                    Actors: { y: 60, alpha: 0, text: { text: ''} },
                    Directors: { y: 50, alpha: 0, text: { text: ''} },
                }
            },
            alpha: 0
        }
    }

    // override _init() {
    //     const { appState } = AppData as AppSetup;
    //     const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
    //     const bgcolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.bgcolor)
    //     this.tag('Container').patch({
    //         color: bgcolor,
    //         alpha: 0.9
    //     })
    // }

    show() {
        this.isVisible = true;
        this.visible = true;
        this.setSmooth('alpha', 1)
    }

    hide() {
        this.isVisible = false;
        this.visible = false;
        this.setSmooth('alpha', 0)
    }

    getPatchObjects(item: ItemNode): any {
        const { appState } = AppData as AppSetup;
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        const bgcolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.bgcolor)

        const infoObj: any = {
            Title: { text: item.title, color: 0xffffffff },
            ItemMetadataWrapper: {
                children: []
            },
            Description: {text: item.description}
        }

        const runtimeAlpha = (item.runtime == 0 ? 0 : 1)
        const ageRatingAlpha = (item.age_appropriate_rating == '' ? 0 : 1)
        const popularityRatingAlpha = (item.popularity_rating == -1 ? 0 : 1)
        const releaseDate = item.release_date
        const actorsAlpha = (item.actors == null ? 0 : 0.7)
        const directorsAlpha = (item.directors == null ? 0 : 0.7)

        if (releaseDate !== '') {
            infoObj.ItemMetadataWrapper.children.push({
                h: 40,
                alpha: 0.7,
                flexItem: { marginLeft: 0, marginRight: 40 },
                text: { text: releaseDate, fontSize: 24, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff },
            })
        }
        if (runtimeAlpha == 1) {
            infoObj.ItemMetadataWrapper.children.push({
                h: 40,
                alpha: 0.7,
                flexItem: { marginLeft: 0, marginRight: 40 },
                text: { text: Helper.secondsToHms(item.runtime), fontSize: 24, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff },
            })
        }
        if (ageRatingAlpha == 1) {
            infoObj.ItemMetadataWrapper.children.push({
                h: 40,
                flexItem: { marginLeft: 0, marginRight: 40 },
                type: Badge,
                title: item.age_appropriate_rating, style: { offsetY: 2, paddingX: 30, backgroundColor: bgcolor, radius: 0, textStyle: { fontSize: 22, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff } }
            })
        }
        if (actorsAlpha) {
          infoObj.Actors = {
            alpha: actorsAlpha,
            text: { text: 'Cast: ' + item.actors.join(', '), fontSize: 24, fontFace: 'Light', wordWrapWidth: 700, lineHeight: 40 },
          }
        }
        if (directorsAlpha) {
          infoObj.Directors = {
            alpha: directorsAlpha,
            text: { text: 'Creators: ' + item.directors.join(', '), fontSize: 24, fontFace: 'Light', wordWrapWidth: 700, lineHeight: 40 },
          }
        }
        this._updateLogo()

        return infoObj
    }

    _updateLogo() {
        const { appState } = AppData as AppSetup
        const appApiConfig = appState?.getAppApiConfig()
        this.tag('LogoContainer').patch({
            Logo: {
                texture: {
                    src: appApiConfig?.appBrandConfig?.header_logo,
                    resizeMode: {
                        h: 60,
                        w: 460,
                        type: 'contain',
                    },
                    type: Lightning.textures.ImageTexture
                },
            }
        })
    }

    set item(item: ItemNode) {
        if (!item) return;
        this.tag('Container').patch({
            InfoTextWrapper: this.getPatchObjects(item),
        })
    }

    override _getFocused() {
        return this;
    }

    _handleClick() {
        if (this.isVisible) {
            this.hide()
        }
    }

}